import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { faLightbulbExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { SelectedFeedback } from '../../utils';

export const StyledMakeEditsDiv = styled.div`
  padding: ${SPACERS.extraLarge};
  .question-text {
    text-align: center;
    margin-top: 0 !important;
  }
  .fyi {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${SPACERS.tiny};
    margin-bottom: ${SPACERS.medium};
    .icon {
      margin-top: -2px;
      width: ${SPACERS.medium};
      height: ${SPACERS.medium};
    }
    .text {
      max-width: 537px;
    }
  }
  .error-text {
    margin-top: ${SPACERS.medium};
  }
`;

export const ErrorText: React.FC = () => {
  return (
    <StyledMakeEditsDiv>
      <TrueImpactText color="critical">
        Unable to open the page, please try refreshing the page.
      </TrueImpactText>
    </StyledMakeEditsDiv>
  );
};

interface StaticTextProps {
  selectedSection: SelectedFeedback & {
    question: NonNullable<SelectedFeedback['question']>;
  };
}

export const StaticText: React.FC<StaticTextProps> = ({ selectedSection }) => {
  if (selectedSection.section.sectionId !== 'impact_summary') return null;
  return (
    <div className="fyi">
      <FontAwesomeIcon icon={faLightbulbExclamation} className="icon" />
      <TrueImpactText variant="body-small" className="text">
        <strong>FYI:</strong> Changing this might lead to additional updates
        needed to your impact model — this is totally fine! If needed, we’ll
        prompt you with additional questions as you make your updates.
      </TrueImpactText>
    </div>
  );
};
